require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-visual-design-use-the-strong-tag-to-make-text-bold.json") })
        }
      }, "path---responsive-web-design-applied-visual-design-use-the-strong-tag-to-make-text-bold");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-visual-design-use-the-strong-tag-to-make-text-bold!./.cache/json/responsive-web-design-applied-visual-design-use-the-strong-tag-to-make-text-bold.json
// module id = 2582
// module chunks = 231608221292675